import React from "react";

function ButtonRepeathandle({
  label,
  type,
  notificationType,
  setNotificationType,
}) {
  return (
    <>
      <span
        className={`valign-wrapper space-between pointer ${
          notificationType === type ? "cercle-purple-text" : ""
        }`}
        style={{ height: "50px" }}
        onClick={() => {
          setNotificationType(type);
        }}
      >
        <h5 className="ml-3 font-cercular-bold">{label}</h5>
        {notificationType === type && (
          <p
            className="cercle-purple"
            style={{ height: "50px", width: "4px" }}
          ></p>
        )}
      </span>
      <hr style={{ height: "2px" }} />
    </>
  );
}

export default ButtonRepeathandle;
